/* eslint-disable import/prefer-default-export */
import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentGpa = ({ studentId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/external-data/student-gpa/${studentId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getGlobalDataSetList = ({ params, version = 'v1' }) =>
  client
    .request({
      params,
      url: `${version}/external-data/data-sets/global-data-sets/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getDataPointList = ({
  studentId,
  attendanceUuid,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/external-data/data-sets/${attendanceUuid}/data-points/`,
      params: {
        studentId,
      },
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getDataSets = ({ params, version = 'v1' }) =>
  client
    .request({
      params,
      url: `${version}/external-data/data-sets/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
